exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".visualization-select-popper .el-select-dropdown__list{padding:5px!important}", ""]);

// exports
